@if (isAdaptersLayoutEnabled) {
  <!-- New layout with sidebar (shows Integrations and Adapters) -->
  <app-sidebar-layout [menuItems]="menuItems" [activeItemId]="activeItemId" (itemSelected)="onItemSelected($event)">
  </app-sidebar-layout>
} @else {
  <!-- Old layout (shows only Integrations page) -->
  <app-integrations></app-integrations>
}
